import { render, staticRenderFns } from "./HotelEditPrice.vue?vue&type=template&id=fcead380&scoped=true&"
import script from "./HotelEditPrice.vue?vue&type=script&lang=ts&"
export * from "./HotelEditPrice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcead380",
  null
  
)

export default component.exports